import * as _ from 'lodash';

import { NoteColor, ProcessStep } from "../constants";
import { Presentation, ShapeType } from "../reducers";
import { decodePresentation, decodePresentationOverviews } from "./encoder";
import * as http from "./store-utils";
import { BoundsType, Point } from "./shape-service";

export interface PresentationOverview {
    readonly id: number,
    readonly name: string,
    readonly created: Date,
    readonly updated: Date,
}

export interface EmptySlide {
    readonly uuid: string,
    readonly x: number,
    readonly y: number,
}

export async function loadAllPresentationOverviews(): Promise<ReadonlyArray<PresentationOverview>> {
    // const data = await http.get("presentation/");
    const data = [{"id":1,"name":"My first presentation","created":[2019,4,4,6,26,14,691459000],"lastUpdate":[2019,4,4,6,27,52,408228000]}];
    return decodePresentationOverviews(data);
}

export async function loadPresentation(presentationId: number): Promise<Presentation> {
    // const data = await http.get(`presentation/${presentationId}/`);
    const data = {"id":1,"processStep":"SKETCH","goals":"","mainMessage":"","audience":"","templateId":1,"notes":[{"uuid":"0f077743-ba6d-4386-9289-e8047d18637a","x":1410.0886,"y":530.6008,"text":"Beziehungen der Hauptpersonen am Anfang","color":"YELLOW"},{"uuid":"c170d5b3-8c85-467c-8bb0-7fcff7a5b249","x":1734.7078,"y":537.1496,"text":"Beziehungen der Hauptpersonen am Ende","color":"YELLOW"}],"slides":[{"uuid":"00edf718-fa32-49b5-8ee9-22d291ec1e4e","x":6561.438,"y":1973.3026,"notes":null,"shapes":[]},{"uuid":"cfa1b40f-d077-4aa4-9457-7e1861fbdb9e","x":5314.9,"y":2039.6732,"notes":null,"shapes":[]}],"textFields":{}};
    return decodePresentation(data);
}

export async function createPresentation(name: string): Promise<number> {
    const id = await http.postWithResponse("presentation", name);
    if (_.isNumber(id)) {
        return _.toNumber(id);
    }
    throw Error(`Creating presentation ${name} failed`);
}

export async function renamePresentation(presentationId: number, name: string): Promise<void> {
    await http.put(`presentation/${presentationId}/`, name);
}

export async function deletePresentation(presentationId: number): Promise<void> {
    await http.del(`presentation/${presentationId}/`);
}

export async function updateProcessStep(presentationId: number, processStep: ProcessStep): Promise<void> {
    // await http.put(`presentation/${presentationId}/process-step/`, processStep);
}


export async function updateBasicData(presentationId: number, goals: string, mainMessage: string, audience: string): Promise<void> {
    // const data = { goals, mainMessage, audience };
    // await http.put(`presentation/${presentationId}/basic-data/`, data);
}

export async function updateTemplateId(presentationId: number, templateId: number): Promise<void> {
    // await http.put(`presentation/${presentationId}/template/`, templateId);
}

export async function createNote(presentationId: number, uuid: string, x: number, y: number, text: string, color: NoteColor): Promise<void> {
    // const note = { uuid, x, y, text, color };
    // await http.post(`presentation/${presentationId}/note/`, note);
}

export async function updateNote(presentationId: number, uuid: string, text: string, color: NoteColor): Promise<void> {
    // const data = { text, color };
    // await http.put(`presentation/${presentationId}/note/${uuid}/`, data);
}

export async function moveNote(presentationId: number, uuid: string, x: number, y: number): Promise<void> {
    await moveNotes(presentationId, [{uuid, x, y}]);
}

export async function moveNotes(presentationId: number, movements: ReadonlyArray<Movement>): Promise<void> {
    // await http.put(`presentation/${presentationId}/note/move/`, movements);
}

export async function deleteNote(presentationId: number, uuid: string): Promise<void> {
    // await http.del(`presentation/${presentationId}/note/${uuid}/`);
}

export async function createSlide(presentationId: number, uuid: string, x: number, y: number): Promise<void> {
    // const slide = { uuid, x, y };
    // await http.post(`presentation/${presentationId}/slide/`, [slide]);
}

export async function createSlides(presentationId: number, slides: ReadonlyArray<EmptySlide>): Promise<void> {
    // await http.post(`presentation/${presentationId}/slide/`, slides);
}

export async function updateSlideNotes(presentationId: number, uuid: string, notes: string): Promise<void> {
    // await http.put(`presentation/${presentationId}/slide/${uuid}/`, notes);
}

export async function moveSlide(presentationId: number, uuid: string, x: number, y: number): Promise<void> {
    await moveSlides(presentationId, [{uuid, x, y}]);
}

export async function moveSlides(presentationId: number, movements: ReadonlyArray<Movement>): Promise<void> {
    // await http.put(`presentation/${presentationId}/slide/move/`, movements);
}

export async function deleteSlide(presentationId: number, uuid: string): Promise<void> {
    // await http.del(`presentation/${presentationId}/slide/${uuid}/`);
}

export async function deleteAllSlides(presentationId: number): Promise<void> {
    // await http.del(`presentation/${presentationId}/slide/`);
}

export async function updateTextField(presentationId: number, key: string, value: string): Promise<void> {
    // await http.put(`presentation/${presentationId}/text-field/`, { key, value });
}

export async function createShape(presentationId: number, slideUuid: string, shapeUuid: string, type: ShapeType, x1: number, y1: number, x2: number, y2: number): Promise<void> {
    // const shape = { uuid: shapeUuid, type, x1, y1, x2, y2 };
    // await http.post(`presentation/${presentationId}/slide/${slideUuid}/shape/`, shape);
}

export async function updateShape(presentationId: number, slideUuid: string, shapeUuid: string, type: ShapeType, x1: number, y1: number, x2: number, y2: number): Promise<void> {
    // const shape = { uuid: shapeUuid, type, x1, y1, x2, y2 };
    // await http.put(`presentation/${presentationId}/slide/${slideUuid}/shape/${shapeUuid}/`, shape);
}

export async function createFreeform(presentationId: number, slideUuid: string, shapeUuid: string, x1: number, y1: number, x2: number, y2: number, points: ReadonlyArray<Point> = []): Promise<void> {
    // const coordsX = points.map(p => p.x);
    // const coordsY = points.map(p => p.y);
    // const shape = { uuid: shapeUuid, type: 'FREEFORM', x1, y1, x2, y2, coordsX, coordsY };
    // await http.post(`presentation/${presentationId}/slide/${slideUuid}/shape/`, shape);
}

export async function updateFreeform(presentationId: number, slideUuid: string, shapeUuid: string, x1: number, y1: number, x2: number, y2: number, points: ReadonlyArray<Point> = []): Promise<void> {
    // const coordsX = points.map(p => p.x);
    // const coordsY = points.map(p => p.y);
    // const shape = { uuid: shapeUuid, type: 'FREEFORM', x1, y1, x2, y2, coordsX, coordsY };
    // await http.put(`presentation/${presentationId}/slide/${slideUuid}/shape/${shapeUuid}/`, shape);
}

export async function createText(presentationId: number, slideUuid: string, shapeUuid: string, x1: number, y1: number, x2: number, y2: number, text: string, boundsType: BoundsType): Promise<void> {
    // const shape = { uuid: shapeUuid, type: 'TEXT', x1, y1, x2, y2, text, boundsType };
    // await http.post(`presentation/${presentationId}/slide/${slideUuid}/shape/`, shape);
}

export async function updateText(presentationId: number, slideUuid: string, shapeUuid: string, x1: number, y1: number, x2: number, y2: number, text: string, boundsType: BoundsType): Promise<void> {
    // const shape = { uuid: shapeUuid, type: 'TEXT', x1, y1, x2, y2, text, boundsType };
    // await http.put(`presentation/${presentationId}/slide/${slideUuid}/shape/${shapeUuid}/`, shape);
}

export async function moveShape(presentationId: number, slideUuid: string, shapeUuid: string, x: number, y: number): Promise<void> {
    // const point = { x, y };
    // await http.put(`presentation/${presentationId}/slide/${slideUuid}/shape/${shapeUuid}/move/`, point);
}

export async function resizeShape(presentationId: number, slideUuid: string, shapeUuid: string, x1: number, y1: number, x2: number, y2: number, boundsType: BoundsType = BoundsType.FIXED): Promise<void> {
    // const bounds = { x1, y1, x2, y2, boundsType };
    // await http.put(`presentation/${presentationId}/slide/${slideUuid}/shape/${shapeUuid}/resize/`, bounds);
}

export async function deleteShape(presentationId: number, slideUuid: string, shapeUuid: string): Promise<void> {
    // await http.del(`presentation/${presentationId}/slide/${slideUuid}/shape/${shapeUuid}/`);
}

interface Movement {
    readonly uuid: string,
    readonly x: number,
    readonly y: number,
}



// WEBPACK FOOTER //
// ./src/services/presentation-store.ts